module.exports = __webpack_public_path__ + "static/media/22_B.8e88fcfd.png";